export const mutations = {
  STORE_EMPLOYEE_DEDUCTIONS(state, employeedeductions) {
    state.employeedeductions = employeedeductions;
  },

  STORE_DEDUCTION_UPDATE(state, deductionId) {
    let Deduction = state.employeedeductions.find(function(employeedeductions) {
      return employeedeductions.id === deductionId;
    });
    state.systemDeduction = Deduction;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/employeedeductions/mutations.js